import React from "react";
import { Container, CssContainer } from "../../components/container";

// In-app Privacy Policy (APP_PRIVACY_POLICY_PAGE.md — content verbatim;
// replaces the public-site link).
export default function PrivacyPolicyView() {
  return /*#__PURE__*/React.createElement("div", {
    className: "territory-view"
  }, /*#__PURE__*/React.createElement(CssContainer, {
    cls: "grid-button space-between margin-squeeze align-end"
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading-label"
  }, "Privacy Policy")), /*#__PURE__*/React.createElement(Container, {
    title: "",
    css: "margin-squeeze"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: "760px",
      fontSize: "14px",
      lineHeight: 1.7
    }
  }, /*#__PURE__*/React.createElement("p", null, "Plunk collects personal data from you only when you register for service or otherwise provide such information voluntarily. Plunk will not share your information with any other businesses or agencies."), /*#__PURE__*/React.createElement("p", null, "Plunk may use cookies* to learn your preferences and enhance your user experience."), /*#__PURE__*/React.createElement("p", null, "Plunk may make changes to the Privacy Policy at any time, however we will never reduce your privacy rights without your consent."), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: "12.5px",
      color: "var(--plk-text-muted)"
    }
  }, "* a small file sent from the website to your computer, the cookie is used to help the internet site identify your browser and store small bits of information that Plunk will use only to better your service."))));
}